module.exports = __webpack_public_path__ + "static/img/son6.1c239fee.png";